export default "__VITE_ASSET__D789DE3s__"